<template>
  <div class="p-15">
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="query.name">
          <el-input placeholder="请输入店铺名称" v-model.trim="searchForm.query.name" />
        </el-form-item>
        <el-form-item prop="query.type">
          <el-select v-model="searchForm.query.type" clearable placeholder="请选择店铺类型">
            <el-option v-for="item in StoreType.options()" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="exportStore" type="primary">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item class="fr">
          <import-export @success="init" :template="templateUrl" :target="exportStockUrl"></import-export>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20">
      <el-table :data="tableData">
        <el-table-column label="店铺名称" prop="name" />
        <el-table-column label="店铺地址" prop="address" ellipsis />
        <el-table-column label="店铺类型" width="120">
          <template #default="{ row }">
            {{ StoreType.filter(row.type).label }}
          </template>
        </el-table-column>
        <el-table-column label="店铺标签" width="140" prop="tag" />
        <el-table-column label="所属平台" prop="platform" />
        <el-table-column label="授权编号" prop="number" width="120" />
        <el-table-column label="店铺唯一编码" prop="code" width="200" />
        <el-table-column label="联系方式" prop="contacts" />
        <el-table-column label="店铺所在地区" prop="areas" ellipsis />
        <el-table-column label="是否隐藏" width="120">
          <template #default="{ row }">
            <el-switch v-model="row.hide" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template #default="{ row }">
            <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" title="你确定要删除该数据么？" @confirm="handleDelete(row)">
              <el-button slot="reference" type="text" class="danger">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination" />
    </el-card>
  </div>
</template>

<script>
import { storeListApi, exportStoreApi, downStoreTemplateApi } from '@/api/store'
import { StoreType } from './enums'
import { cloneDeep } from 'lodash'
import {categoryRemoveApi} from "@/api/category";

export default {
  data() {
    return {
      searchForm: {
        query: {
          name: undefined,
          type: undefined
        },
        pagination: {
          currentPage: 1,
          limit: 10
        }
      },
      tableData: [],
      total: 0,
      templateUrl: downStoreTemplateApi.path,
      exportStockUrl: exportStoreApi.path,
      StoreType
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    changePage({ pagination }) {
      this.searchForm.pagination = pagination
      this.init()
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
    async init() {
      const param = cloneDeep(this.searchForm)
      param.query.name && (param.query.name = `%${param.query.name}%`)
      param.sorts = { id: 'asc' }
      const { collection, meta } = await storeListApi.paging(param)
      this.tableData = collection
      this.total = meta.total
    },
    async exportStore() {
      const param = cloneDeep(this.searchForm)
      param.query.name && (param.query.name = `%${param.query.name}%`)
      this.$linkHelper.redirect(this.exportStockUrl, param.query)
    },
    async handleDelete({ id }) {
      await storeListApi.remove(id);
      this.$message.success('删除成功')
      await this.init()
    },
    async handleUpdate(row) {
      await storeListApi.update(row.id, { hide: row.hide })
      this.$message.success(`修改店铺 ${row.name} 为${row.hide ? '隐藏' : '显示'}`)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped></style>
